import { createSlice } from "@reduxjs/toolkit";
import { Testimonials } from "../../Api/Api";

const TestimonialsSlice = createSlice({
  name: "testimonials",
  initialState: {
    testimonials: [],
    loading: false,
    error: null
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(Testimonials.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(Testimonials.fulfilled, (state, action) => {
        state.testimonials = action.payload;
        state.loading = false;
      })
      .addCase(Testimonials.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export default TestimonialsSlice.reducer;